import React, { Component } from "react";
import {
  Box,
  FormControl,
  Grid,
  IconButton,
  Modal,
  TextField,
  withStyles,
} from "@material-ui/core";
import TicketLayout, { ContentLayout } from "./layout";
import EventHeader from "../EventDetails/eventHeader";
import { styleClasses } from "./ticketsStyleClasses";
import { Button } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { Close, CloseSharp, Delete } from "@material-ui/icons";
import {
  addOrderForm,
  updateOrderForm,
  deleteOrderForm,
  GetAllOrderFormFieldsByEventId,
} from "../../../../Actions/eventActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Loader from "../../../../Helper/loader/loader";
import AddIcon from "@material-ui/icons/Add";
import { checkIfEventExists } from "../../../../Helper/Validations";
import { cloneDeep } from "lodash";
import { eventApis, Text, Tickets } from "../../../../Constants";
import { axiosE } from "../../../../Service/service";
import DeleteConfirmationModal from "../EventAttendence/Component/ModalAction/DeleteConfirmationDialog";
import * as constants from "../../../../Constants";
import Switch from "react-switch";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import {toast, ToastContainer} from "react-toastify";

const styles = {
  eventCreateTicketContentWrapper: styleClasses.eventCreateTicketContentWrapper,
  generateHeight: styleClasses.generateHeight,
  addButton: styleClasses.addButton,
  createButtonAddText: styleClasses.createButtonAddText,
  createButtonPlusIcon: styleClasses.createButtonPlusIcon,
  addUpdateModal: styleClasses.addUpdateModal,
  addUpdateModalMainWrapper: styleClasses.addUpdateModalMainWrapper,
  addUpdateModalHeader: styleClasses.addUpdateModalHeader,
  addUpdateModalHeaderText: styleClasses.addUpdateModalHeaderText,
  addUpdateModalButtonWrapper: {
    ...styleClasses.addUpdateModalButtonWrapper,
    marginTop: "20px",
  },
  addUpdateModalButtonWrapperCondition: {
    display: "flex",
    gap: "10px",
    width: "100%",
    padding: "30px",
    alignItems: "center",
    justifyContent: "center",
    borderTop: "1px solid #ced4da",
    marginTop: "auto",
    textAlign: "center",
  },
  addUpdateModalButtonCancel: styleClasses.addUpdateModalButtonCancel,
  addUpdateModalButtonSave: styleClasses.addUpdateModalButtonSave,
  addUpdateModalCloseIcon: styleClasses.addUpdateModalCloseIcon,
  termsAndConditionsModal: {
    top: "50%",
    left: "50%",
    height: "fit-content",
    display: "flex",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    alignItems: "center",
    borderRadius: "10px",
    flexDirection: "column",
    justifyContent: "flex-start",
    backgroundColor: "white",
    width: "100%",
    maxWidth: "700px",
  },

  addCustomLabelModal: {
    top: "50%",
    left: "50%",
    width: "648px",
    height: "231px",
    display: "flex",
    padding: "10px",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    alignItems: "center",
    borderRadius: "10px",
    flexDirection: "column",
    justifyContent: "center",
    gap: "30px",
    backgroundColor: "white",
  },
  deleteModalSaveAndCancelButton: styleClasses.deleteModalSaveAndCancelButton,
  // Save And Continue Button
  saveAndContinueButton: styleClasses.saveAndContinueButton,
  saveAndContinueButtonWrapper: styleClasses.saveAndContinueButtonWrapper,
  createEventFAQInputLabel: {
    fontSize: "16px",
    fontWeight: "550",
  },
  createEventFAQInputText: {
    fontSize: "16px",
    marginTop: "-10px",
  },
  orderForm: {
    backgroundColor: "#FAFAFA",
    width: "100%",
    padding: "10px",
    boxShadow: "rgb(99 99 99 / 20%) 0px 2px 8px 0px",
    paddingTop: "20px",
  },
  addLabel: {
    fontSize: "16px",
    color: "grey",
    cursor: "pointer",
  },
  eventDetailsAboutInputHelperText: {
    textAlign: "end",
    margin: 0,
    fontSize: "9px",
    position: "absolute",
    right: "6px",
    bottom: "6px",
  },
};

const defaultFields = [...cloneDeep(Tickets.orderForm.defaultFields)];

class orderForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields2: [],
      nextId: 1,
      newDynamicFields: [],
      newDynamicId: 1,
      tickets: [],
      fields: [...defaultFields],
      questions: [...cloneDeep(Tickets.orderForm.fields)],
      addModal: false,
      customFieldModal: { show: false, index: "" },
      customTextFileds: [],
      loading: false,
      termsAndConditions: "",
      currentTermsAndConditions: "",
      termsAndConditionsFormFieldId: "",
      termsAndConditionsModal: false,
      showConfirmationDialog: false,
      deletingCustomFieldIndex: null,
      characterCount: 0,
      maxCharacters: 4000,
      checked: false,
      ticketsTypes: [],
      updatedField: [],
      fieldToDelete: null,
    };
  }

  termsAndConditionsModal = (state) => {
    this.setState({
      termsAndConditionsModal: state,
      currentTermsAndConditions: "",
    });
    if (state) {
      this.setState({
        currentTermsAndConditions: this.state.termsAndConditions,
      });
    }
  };

  GetTicketsByEventID = (eventId) => {
    axiosE(`${eventApis.getTicketByEventId}${eventId}`).then((res) => {
      const tickets = res.data.results.ListTicket;
      if (tickets && tickets.length > 0) {
        const isRecurring = tickets?.some(
            (ticket) =>
                (ticket?.RecurringTicket === "True" ||
                    ticket?.RecurringTicket === "true") &&
                ticket.Status !== "Deleted"
        );
        localStorage.setItem("isRecurring", isRecurring);
        this.setState({
          tickets: tickets.map((ticket, index) => ({
            TicketId: ticket.TicketId,
            TicketName: ticket.TicketName,
          })),
        });
      }
    });
  };

  handleIsForAllTicketsChange = (Id, fieldId) => {
    const { tickets } = this.state;
    if (fieldId) {
      this.setState((prevState) => ({
        updatedField: [...prevState.updatedField, fieldId],
      }));
    }
    this.setState((prevState) => ({
      newDynamicFields: prevState.newDynamicFields.map((field) =>
          (field.FormFieldId ? field.FormFieldId === Id : field.id === Id)
              ? {
                ...field,
                isForAllTickets: !field.isForAllTickets,
                associatedIds: field.isForAllTickets
                    ? []
                    : tickets.map((ticket) => ticket.TicketId),
              }
              : field
      ),
    }));
  };

  handleChange = (e) => {
    this.setState((prevState) => ({
      ...prevState,
      currentTermsAndConditions: e.target.value,
      characterCount: e.target.value.length
    }));
  };

  handleAddDynamicField = (fieldType) => {
    const { eventId } = this.props;
    const newField = {
      id: this.state.newDynamicId,
      value: fieldType === "checkbox" ? "false" : "",
      type: fieldType,
      EventId: eventId,
      FieldName: "",
      required: false,
      DefaultValue: "",
      DropDownItems: [],
      FieldType: fieldType,
      Options: [],
      isForAllTickets: false,
      associatedIds: [],
    };

    this.setState((prevState) => ({
      newDynamicFields: [...prevState.newDynamicFields, newField],
      newDynamicId: prevState.newDynamicId + 1,
    }));
  };

  handleDynamicFieldChange = (id, event, FormFieldId) => {
    if (FormFieldId) {
      this.setState((prevState) => ({
        updatedField: [...prevState.updatedField, FormFieldId],
      }));
    }
    const field = this.state.newDynamicFields.find((f) =>
        f.FormFieldId ? f.FormFieldId === id : f.id === id
    );
    const value =
        field.type === "checkbox"
            ? event.target.checked.toString()
            : event.target.value;
    this.setState((prevState) => ({
      newDynamicFields: prevState.newDynamicFields.map((field) =>
          (field.FormFieldId ? field.FormFieldId === id : field.id === id)
              ? { ...field, FieldName: value }
              : field
      ),
    }));
  };

  handleDynamicFieldRequiredChange = (id, checked, FormFieldId) => {
    if (FormFieldId) {
      this.setState((prevState) => ({
        updatedField: [...prevState.updatedField, FormFieldId],
      }));
    }
    this.setState((prevState) => ({
      newDynamicFields: prevState.newDynamicFields.map((field) =>
          (field.FormFieldId ? field.FormFieldId === id : field.id === id)
              ? { ...field, required: checked }
              : field
      ),
    }));
  };

  handleDeleteDynamicField = async (id, formId) => {
    this.setState((prevState) => ({
      showConfirmationDialog: false,
      fieldToDelete: null,
    }));
    if (formId) {
      const { data } = await axiosE.post(eventApis.deleteOrderForm, {
        FormFieldId: formId,
      });
      if (data.results.ResponseCode) {
        this.setState((prevState) => ({
          newDynamicFields: prevState.newDynamicFields.filter(
              (field) => field.FormFieldId !== formId
          ),
          fields: prevState.fields.filter((field) => field.FormFieldId !== formId)
        }));
        this.setState((prevState) => ({
          updatedField: prevState.updatedField.filter((id) => id !== formId),
        }));
      }
    } else {
      this.setState((prevState) => ({
        newDynamicFields: prevState.newDynamicFields.filter(
            (field) => field.id !== id
        ),
      }));
    }
  };

  changeInput = (id, fieldId) => {
    const inputField = document.getElementById(`input-${id}`);
    const value = inputField?.value.trim();
    if (value.length === 0) return;
    if (fieldId) {
      this.setState((prevState) => ({
        updatedField: [...prevState.updatedField, fieldId],
      }));
    }

    if (value) {
      this.setState((prevState) => ({
        newDynamicFields: prevState.newDynamicFields.map((field) =>
            (field?.FormFieldId ? field.FormFieldId === id : field.id === id)
                ? {
                  ...field,
                  DropDownItems:
                      field.DropDownItems && field.DropDownItems.length > 0
                          ? [...field.DropDownItems, value]
                          : [value],
                }
                : field
        ),
      }));
      inputField.value = "";
    }
  };

  handleCheckboxChange = (id, key, FormFieldId) => {
    const existingField = this.state.newDynamicFields.find((field) =>
        field.FormFieldId ? field.FormFieldId === id : field.id === id
    );
    if (FormFieldId) {
      this.setState((prevState) => ({
        updatedField: [...prevState.updatedField, FormFieldId],
      }));
    }
    if (existingField.associatedIds.includes(key)) {
      this.setState((prevState) => ({
        newDynamicFields: prevState.newDynamicFields.map((field) =>
            (field.FormFieldId ? field.FormFieldId === id : field.id === id)
                ? {
                  ...field,
                  isForAllTickets: false,
                  associatedIds: field.associatedIds.filter(
                      (item) => item !== key
                  ),
                }
                : field
        ),
      }));
    } else {
      const allTicketIds = this.state.tickets.map((t) => t.TicketId);
      this.setState((prevState) => {
        const updatedFields = prevState.newDynamicFields.map((field) => {
          const isPossible = field.FormFieldId
              ? field.FormFieldId === id
              : field.id === id;
          if (isPossible) {
            const updatedAssociatedIds = field.associatedIds.includes(key)
                ? field.associatedIds.filter((item) => item !== key)
                : [...field.associatedIds, key];

            const isAllTickets = allTicketIds.every((ticketId) =>
                updatedAssociatedIds.includes(ticketId)
            );
            return {
              ...field,
              associatedIds: updatedAssociatedIds,
              isForAllTickets: isAllTickets,
            };
          }
          return field;
        });

        return { newDynamicFields: updatedFields };
      });
    }
  };

  handleDeleteDropDownItem = (id, item, fieldId) => {
    if (fieldId) {
      this.setState((prevState) => ({
        updatedField: [...prevState.updatedField, fieldId],
      }));
    }
    this.setState((prevState) => ({
      newDynamicFields: prevState.newDynamicFields.map((field) =>
          (field.FormFieldId ? field.FormFieldId === id : field.id === id) &&
          field.DropDownItems
              ? {
                ...field,
                DropDownItems: field.DropDownItems.filter(
                    (_, index) => index !== item
                ),
              }
              : field
      ),
    }));
  };

  handleDynamicFieldDefaultChange = (id, value) => {
    this.setState((prevState) => ({
      newDynamicFields: prevState.newDynamicFields.map((field) =>
          field.id === id ? { ...field, DefaultValue: value } : field
      ),
    }));
  };

  /* MARK :- Enable Disable Each Attendee Details Required or not */
  handleSwitchChange = () => {
    const { eventId } = this.props;

    this.setState((prevState) => {
      const data = {
        EventId: eventId,
        isAnonymousAllowed: prevState.checked,
      };

      this.updateAnonymousAllowed(data);

      // No immediate state change required here since it's handled after the API response
      return null;
    });
  };

  updateAnonymousAllowed = (data, isCalledFromAddField = false) => {
    // Send the API request and update the state
    axiosE
        .post(eventApis.updateAnonymousAllowed, data)
        .then(({ data }) => {
          const parsedResults = JSON.parse(data.results); // Parse the JSON string

          localStorage.setItem(
              "isAnonymousAllowed",
              JSON.stringify(parsedResults.CurrentValue)
          );
          this.setState({
            checked: parsedResults.PreviousValue, // Access PreviousValue after parsing
          });

          if (isCalledFromAddField) {
            toast("Collecting individual attendee information has been TOGGLED ON in order to accurately capture information correctly at checkout. ");
          }
        })
        .catch((err) => {
          console.error(err);
        });
  }

  handleCustomQuestionSwitchChange = (checked, index) => {
    const { questions } = this.state;

    const updatedQuestions = questions.map((question, i) => {
      if (i === index) {
        return { ...question, toggleState: checked };
      }
      return question;
    });

    this.setState({ questions: updatedQuestions });
  };

  componentDidMount() {
    checkIfEventExists(this.props.history, this.props.eventId);

    this.getTicketsCat();

    this.getOrderFormFields();
  }

  getTicketsCat = (discounts, isReturn = false) => {
    const { eventId } = this.props;
    axiosE
        .get(`${eventApis.getTicketByEventId}/${eventId}`)
        .then(({ data }) => {
          const Tickets = data.results.ListTicket;
          if (Tickets && Tickets.length > 0) {
            this.setState({
              tickets: Tickets,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.setState({ loading: false });
        });
  };


  getOrderFormFields() {
    const { eventId } = this.props;

    this.setState({ loading: true });
    axiosE
        .get(eventApis.getOrderFormByEventId + eventId)
        .then((res) => {
          this.setState({
            checked: !res.data.results.IsAnonymousAllowed,
          });

          const orderForms = res.data.results.ListOrderFormField || [];

          // Send Default Fields to remote

          defaultFields.map((field) => {
            const isExcluded = orderForms?.some(orderForm => orderForm.FieldName === field.label);
            if (!isExcluded) {
              this.sendOrderForm(field, true);
            }
          });

          // if (
          //   orderForms !== null &&
          //   orderForms !== undefined &&
          //   orderForms.length > 0
          // ) {
          //   ["Phone", "Email", "Full Name"].map((item) => {
          //     const index = orderForms?.findIndex((object) => {
          //       return object?.FieldName === item;
          //     });
          //     const toIndex = 0;
          //     const element = orderForms.splice(index, 1)[0];
          //     orderForms.splice(toIndex, 0, element);
          //   });
          // }

          if (orderForms && orderForms[0] && orderForms?.length > 0) {
            const termsAndConditionsForm = orderForms.filter(
                (form) => form.FieldName === "Terms And Conditions"
            );
            if (termsAndConditionsForm && termsAndConditionsForm[0]) {
              this.setState({
                termsAndConditions: termsAndConditionsForm[0].DefaultValue,
                termsAndConditionsFormFieldId:
                termsAndConditionsForm[0].FormFieldId,
              });
            }
            const orderFormWithoutTermsAndConditions = orderForms.filter(
                (form) => form.FieldName !== "Terms And Conditions"
            );
            this.setState((prevstate) => ({
              ...prevstate,
              fields: [
                ...defaultFields,
                ...orderFormWithoutTermsAndConditions
                    .filter((field) =>
                        field.FieldName !== "Phone" &&
                        field.FieldName !== "Full Name" &&
                        field.FieldName !== "Email"
                    )
                    .map((field) => {
                      return {
                        label: field?.FieldName,
                        required: field?.RequiredField === "True",
                        FormFieldId: field?.FormFieldId,
                        FieldType: field?.FieldType,
                        Options: field?.Options?.length > 0 ? JSON.parse(field.Options) : [],
                        associatedIds: field?.AssociatedIds || [],
                        IsForAllTickets: field?.IsForAllTickets,
                      };
                    }),
              ],

              newDynamicFields: orderFormWithoutTermsAndConditions.filter((field) =>

                  field.FieldName !== "Phone" &&
                  field.FieldName !== "Full Name" &&
                  field.FieldName !== "Email" &&
                  field.FieldType !== "text"

              ).map(
                  (field) => {
                    return {
                      FieldName: field?.FieldName,
                      required: field?.RequiredField === "True",
                      FormFieldId: field?.FormFieldId,
                      type: this.getType(field.FieldType),
                      FieldType: field?.FieldType,
                      associatedIds: field?.AssociatedIds || [],
                      RequiredField: field?.RequiredField,
                      DefaultValue: field?.DefaultValue,
                      DropDownItems:
                          field.FieldType === "Radio" ||
                          field.FieldType === "Multi-Select" ||
                          field.FieldType === "Dropdown"
                              ? field?.Options?.length > 0
                                  ? JSON.parse(field.Options)
                                  : []
                              : field?.Options,
                      EventId: field?.EventId,
                      isForAllTickets: field?.IsForAllTickets,
                    };
                  }
              ),
              questions: this.setQuestionOnMount(
                  orderFormWithoutTermsAndConditions
              ),
            }));
          }
        })
        .finally(() => {
          this.setState({ loading: false });
        });
  }

  setQuestionOnMount = (stateFields) => {
    const origArr = this.state.questions;
    const updatingArr = stateFields;

    for (var i = 0, l = updatingArr.length; i < l; i++) {
      let notFound = true;
      for (var j = 0, ll = origArr.length; j < ll; j++) {
        if (
            updatingArr[i].FieldName === origArr[j].label ||
            updatingArr[i].FieldName === "Email" ||
            updatingArr[i].FieldName === "Full Name" ||
            updatingArr[i].FieldName === "Phone"
        ) {
          notFound = false;
        }
      }
      if (notFound) {
        origArr.push({
          label: updatingArr[i].FieldName,
          value: updatingArr[i].FieldName,
          required: updatingArr[i].RequiredField,
          FormFieldId: updatingArr[i].FormFieldId,
          state: true,
          type: "custom",
        });
      }
    }

    for (var i = 0, l = origArr.length; i < l; i++) {
      for (var j = 0, ll = updatingArr.length; j < ll; j++) {
        if (origArr[i].label === updatingArr[j].FieldName) {
          origArr.splice(i, 1, {
            label: updatingArr[j].FieldName,
            state: true,
            value: updatingArr[j].FieldName,
            FormFieldId: updatingArr[j].FormFieldId,
            type: origArr[i].type === "custom" ? "custom" : "",
          });
          break;
        }
      }
    }

    return origArr;
  };

  handleAddModal = () => {
    this.setState({ addModal: !this.state.addModal });
  };

  customBoxStyle = (name) => {
    return { width: "100%" };
  };

  customStyles = (field, fieldsPresent) => {
    if (field && field.label === "Text") {
      return {
        cursor: "pointer",
        borderRadius: "5px",
        padding: "20px 3px",
        fontSize: "16px",
        backgroundColor: "#FFFFFF",
        color: "black",
        border: "1px solid rgb(224, 224, 224)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
    } else {
      return {
        cursor: "pointer",
        borderRadius: "5px",
        border: "1px solid rgb(224, 224, 224)",
        padding: "20px 3px",
        fontSize: "16px",
        backgroundColor: field && field.state ? "rgb(182, 14, 181)" : "#FFFFFF",
        color: field && field.state ? "white" : "black",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
    }
  };

  // Function for generating fields with bold labels
  fieldWithBoldTextGenerator = (fields) => {
    return fields.map((field, index) => (
        <Grid
            item
            xs={6}
            key={index}
            align="center"
            justifyContent="center"
            style={this.customBoxStyle(field.label)}
        >
          <Box
              onClick={() => this.handleAddDynamicField(field.label)}
              sx={this.customStyles(
                  field,
                  this.state.questions.some((question) => question.type === "custom")
              )}
              style={{ height: "100%" }}
          >
            {field.label}
          </Box>
        </Grid>
    ));
  };

  // Function for generating other fields
  regularFieldGenerator = (fields) => {
    return fields.map((field, index) => (
        <Grid
            item
            xs={6}
            key={index}
            align="center"
            justifyContent="center"
            style={this.customBoxStyle(field.label)}
        >
          <Box
              onClick={() => this.changeFieldState(index)}
              sx={this.customStyles(
                  field,
                  this.state.questions.some((question) => question.type === "custom")
              )}
              style={{ height: "100%" }}
          >
            {field.label}
          </Box>
        </Grid>
    ));
  };

  // Main fieldBoxGenerator function
  fieldBoxGenerator = (questions) => {
    const boldFields = questions.filter(
        (field) =>
            field.label === "Text" ||
            field.label === "Dropdown" ||
            field.label === "Single Choice" ||
            field.label === "Multiple Choice"
    );

    const regularFields = questions.filter(
        (field) =>
            field.label !== "Text" &&
            field.label !== "Dropdown" &&
            field.label !== "Single Choice" &&
            field.label !== "Multiple Choice"
    );

    return (
        <>
          {this.regularFieldGenerator(regularFields)}
          {this.fieldWithBoldTextGenerator(boldFields)}
        </>
    );
  };

  addCustomLabelField = (fieldType) => {
    const newField = {
      id: this.state.nextId,
      value: fieldType === "checkbox" ? "false" : "",
      type: fieldType,
    };

    this.setState((prevState) => ({
      newDynamicFields: [...prevState.newDynamicFields, newField],
      nextId: prevState.nextId + 1,
    }));
  };

  saveAndContinue = () => {
    const { classes } = this.props;
    let customField = this.state.fields.filter(
        (question) => question.label === "Text"
    );

    return (
        <div className={classes.saveAndContinueButtonWrapper}>
          <Button
              className={classes.saveAndContinueButton}
              variant={"contained"}
              onClick={() => this.props.history.push("Discounts")}
          >
            {Text.SaveAndContinue}
          </Button>
        </div>
    );
  };

  sendOrderForm = async (field) => {
    const { eventId } = this.props;
    let res;
    if (field.type === "custom") {
      res = await this.addFormField({
        EventId: eventId,
        FieldName: field.value,
        RequiredField: false,
        FieldType: "text",
        isForAllTickets: true,
      });
    } else {
      res = await this.addFormField({
        EventId: eventId,
        FieldName: field.label,
        RequiredField: true,
        FieldType: "text",
        isForAllTickets: true,
      });
    }
    return res;
  };

  addFormField = async (data) => {
    // const { addOrderForm } = this.props;
    const res = await axiosE.post(eventApis.addOrderForm, data);
    return res;
  };

  updateFormField = async (data) => {
    const { updateOrderForm, eventId } = this.props;
    const res = await updateOrderForm({
      FormFieldId: data.FormFieldId,
      EventId: eventId,
      FieldName: data.label,
      RequiredField: data.required || false,
    });
    return res;
  };

  //   ((question.label === "Text Question" ||
  //     question.label === "Dropdown Question" ||
  //     question.label === "Single Choice" ||
  //     question.label === "Multiple Choice") && question.type !== "custom")
  // )

  getFieldType = (type) => {
    switch (type) {
      case "Text":
        return "Text";
      case "Dropdown":
        return "Dropdown";
      case "Single Choice":
        return "Radio";
      case "Multiple Choice":
        return "Multi-Select";
      default:
        return "text";
    }
  };

  getType = (type) => {
    switch (type) {
      case "Text":
        return "Text";
      case "Dropdown":
        return "Dropdown";
      case "Radio":
        return "Single Choice";
      case "Multi-Select":
        return "Multiple Choice";
      default:
        return "text";
    }
  };

  addFields = async () => {
    const { newDynamicFields } = this.state;

    // Helper function to add a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    // Fire Up Loading Animation
    this.setState({ loading: true, addModal: false });

    // Remove id, value, type and DropDownItems from the array
    const normalizedFields = newDynamicFields.map((field) => {
      const { id, value, type, DropDownItems, required, ...rest } = field;
      return {
        ...rest,
        FieldType: this.getFieldType(type),
        Options: DropDownItems.length > 0 ? JSON.stringify(DropDownItems) : "",
        RequiredField: required,
      };
    });

    // Calling this api in loop since it doesn't support bulk insertion with delay of 1 second
    for (const field of normalizedFields) {
      await delay(1000);
      if (field.FormFieldId) {
        if (this.state.updatedField.includes(field.FormFieldId)) {
          await axiosE.post(eventApis.updateOrderForm, field);
        }
      } else {
        await axiosE.post(eventApis.addOrderForm, field);
      }
    }

    // Clear updatedField after processing
    this.setState({ updatedField: [] });

    // Get currently active state questions
    let currentActiveState = [];
    this.state.questions.forEach((question) => {
      if (question.state) {
        currentActiveState.push(question);
      }
    });

    // Identify newly added fields
    let newFields = newDynamicFields.filter(
        (field) => !this.state.fields.some((existing) => existing.label === field.type)
    );

    // Identify fields to be deleted
    let deleteFields = this.getFilteredArray(
        this.state.fields,
        currentActiveState
    );

    const defaultFieldsNames = Array.from(
        defaultFields,
        (field) => field.label
    );

    // Identify added custom fields excluding Full Name, Phone, and Email
    const addedCustomFields = newFields.filter(
        (field) => !defaultFieldsNames.includes(field.label)
    );

    // Remove default fields from deletion list
    deleteFields = deleteFields.filter(
        (field) => !defaultFieldsNames.includes(field.label)
    );

    // Delete fields from remote
    for (let field of deleteFields) {
      await this.deleteFromRemote(field).then((res) => {
        this.setState((prevState) => ({
          questions: prevState.questions.map((question) => {
            if (question && question.label === field.label) {
              if (question && question.type !== "custom") {
                return { label: question.label, state: false };
              }
            }
            return question;
          }),
          fields: prevState.fields.filter(
              (field2) => field2.label !== field.label
          ),
        }));
      });
    }

    // // Add fields to remote
    let fieldsInPromise = [];
    for (const field of currentActiveState) {
      if (field.hasOwnProperty("FormFieldId")) {
        this.setState((prevState) => ({
          fields: [...defaultFields, ...fieldsInPromise, field],
        }));
        fieldsInPromise.push(field);
      } else {
        await delay(100); // Adding a 0.5-second delay between API calls
        try {
          const res = await this.sendOrderForm(field);
          this.setState((prevState) => ({
            fields: [
              ...defaultFields,
              ...fieldsInPromise,
              { ...field, FormFieldId: res?.FormFieldId },
            ],
            questions: prevState.questions.map((ques) =>
                ques.label === field.label
                    ? { ...field, FormFieldId: res?.FormFieldId }
                    : ques
            ),
          }));
          fieldsInPromise.push({ ...field, FormFieldId: res?.FormFieldId });
        } catch (error) {
          console.error("Error sending order form:", error);
        }
      }
    }

    // Call getOrderFormFields to refresh state
    this.getOrderFormFields();

    const termsFieldName = "Terms & Conditions";
    // If custom fields are added and isAnonymousAllowed is true, update it (excluding Terms & Conditions)
    const addedFieldsWithoutTerms = addedCustomFields.filter(
        (field) => field.label !== termsFieldName
    );

    if (addedFieldsWithoutTerms.length > 0 && !this.state.checked) {
      const { eventId } = this.props;

      const data = {
        EventId: eventId,
        isAnonymousAllowed: false,
      };
      this.updateAnonymousAllowed(data, true);
    }

    // Set loading to false only after all custom fields have been processed
    this.setState({
      loading: false,
    });
  };

  deleteFromRemote = async (field) => {
    const { deleteOrderForm } = this.props;

    const res = await deleteOrderForm({
      FormFieldId: field.FormFieldId,
    });

    return res;
  };

  getFilteredArray = (ar1, ar2) => {
    // existing fields, current fields
    let newArray = [];
    for (let existingField of ar1) {
      let noPresent = true;
      for (let currentField of ar2) {
        if (existingField.FormFieldId === currentField.FormFieldId)
          noPresent = false;
      }
      if (noPresent) newArray.push(existingField);
    }

    return newArray;
  };
  changeFieldState = (index) => {
    let questions = this.state.questions;
    questions[index].state = !questions[index].state;
    this.setState({ questions });
  };

  addModal = () => {
    const { classes } = this.props;
    const { addModal, questions } = this.state;

    return (
        <Modal open={addModal} onClose={this.handleAddModal}>
          <Box className={classes.addUpdateModal}>
            <div className={classes.addUpdateModalMainWrapper}>
              <div>
                <div className={classes.addUpdateModalHeader}>
                  <div className={classes.addUpdateModalCloseIcon}>
                    <IconButton onClick={this.handleAddModal}>
                      <Close height={30} width={30} />
                    </IconButton>
                  </div>
                  <p className={classes.addUpdateModalHeaderText}>
                    {this.state.fields.length > 2
                        ? "Add/Remove Question"
                        : "Add Question"}
                  </p>
                </div>
                <Grid container spacing={3} style={{ paddingBottom: "20px" }}>
                  {this.fieldBoxGenerator(
                      questions.filter(
                          (question) =>
                              question.label !== "Text" &&
                              question.label !== "Dropdown" &&
                              question.label !== "Single Choice" &&
                              question.label !== "Multiple Choice" &&
                              question.type !== "custom"
                      )
                  )}
                  <Grid item xs={12}>
                    <div
                        style={{
                          borderTop: "1px solid #ced4da",
                          marginTop: "20px",
                        }}
                    />
                    <p style={{ marginTop: "20px" }}>
                      <strong>Create custom questions below:</strong> These can be
                      optional or required and can apply to all or only selected
                      ticket types.
                    </p>

                    <Grid
                        container
                        spacing={3}
                        style={{ paddingBottom: "20px", paddingTop: "20px" }}
                    >
                      {/* Render custom question fields after "Create custom questions below" */}
                      {this.fieldBoxGenerator(
                          questions.filter(
                              (question) =>
                                  (question.label === "Text" ||
                                      question.label === "Dropdown" ||
                                      question.label === "Single Choice" ||
                                      question.label === "Multiple Choice") &&
                                  question.type !== "custom"
                          )
                      )}
                    </Grid>
                  </Grid>
                  <div
                      style={{
                        marginLeft: "15px",
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        width: "100%",
                      }}
                  >
                    {this.state.newDynamicFields.map((field) => (
                        <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "start",
                              flexDirection: "column",
                              width: "100%",
                              background: "#FAFAFA",
                              margin: "10px 0px",
                              padding: "5px",
                            }}
                            key={field.id}
                            className="field-item"
                        >
                          <div
                              key={field.id}
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "start",
                                justifyContent: "start",
                                flexDirection: "column",
                              }}
                          >
                            <div
                                style={{
                                  marginBottom: "20px",
                                  width: "100%",
                                }}
                            />

                            {/* Toggle Switch */}
                            <div
                                item
                                style={{
                                  display: "flex",
                                  marginBottom: "10px", // Space below the toggle
                                  width: "100%"
                                }}
                            >
                              <div
                                  style={{
                                    display: "flex",
                                    width: "100%"
                                  }}
                              >
                                <Switch
                                    onLabel="ON"
                                    offLabel="OFF"
                                    onChange={(checked) =>
                                        this.handleDynamicFieldRequiredChange(
                                            field.FormFieldId || field.id,
                                            checked,
                                            field.FormFieldId
                                        )
                                    }
                                    checked={field.required || false}
                                    checkedIcon={false}
                                    uncheckedIcon={false}
                                    offColor="#E74C3C"
                                    onColor="#080"
                                />
                                <p
                                    style={{
                                      fontSize: "14px",
                                      marginRight: "10px",
                                      marginLeft: "10px",
                                      marginTop: "5px",
                                    }}
                                >
                                  Make this question required
                                </p>
                              </div>
                              <div>
                              <IconButton
                                  onClick={() =>
                                      this.deleteCustomField(
                                          field.id,
                                          field.FormFieldId
                                      )
                                  }
                                  style={{
                                    transform: "scale(1.5)",
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                              >
                                <Delete height={24} width={24} />
                              </IconButton>
                              </div>
                            </div>
                            <label>{field.type}: </label>
                            <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "start",
                                  alignItems: "start",
                                  width: "100%",
                                }}
                            >
                              {field.type === "Text" && (
                                  <Box
                                      display="flex"
                                      alignItems="center"
                                      style={{ width: "100%" }}
                                  >
                                    <TextField
                                        value={field.FieldName}
                                        onChange={(e) =>
                                            this.handleDynamicFieldChange(
                                                field.FormFieldId || field.id,
                                                e,
                                                field.FormFieldId
                                            )
                                        }
                                        placeholder="Type Question Label"
                                        variant="outlined"
                                        style={{ width: "100%", position: "relative" }}
                                        inputProps={{
                                          style: {
                                            fontSize: "16px",
                                          },
                                          maxLength: 75,
                                        }}
                                        helperText={`${field.FieldName.length}/75`}
                                        FormHelperTextProps={{
                                          className:
                                          classes.eventDetailsAboutInputHelperText,
                                        }}
                                    />
                                  </Box>
                              )}
                              {field.type === "Dropdown" && (
                                  <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        width: "100%",
                                      }}
                                  >
                                    <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                    >
                                      <TextField
                                          value={field.FieldName}
                                          placeholder="Type Question Label"
                                          onChange={(e) =>
                                              this.handleDynamicFieldChange(
                                                  field.FormFieldId || field.id,
                                                  e,
                                                  field.FormFieldId
                                              )
                                          }
                                          variant="outlined"
                                          style={{
                                            width: "100%",
                                            position: "relative",
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: "16px",
                                            },
                                            maxLength: 75,
                                          }}
                                          helperText={`${field.FieldName.length}/75`}
                                          FormHelperTextProps={{
                                            className:
                                            classes.eventDetailsAboutInputHelperText,
                                          }}
                                      />
                                    </Box>

                                    <FormGroup
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "20px",
                                        }}
                                    >
                                      <FormControl
                                          fullWidth
                                          sx={{ marginBottom: "20px" }}
                                      >
                                        <Select
                                            value={"Please Select"}
                                            // onChange={(e) =>
                                            //   this.handleDynamicFieldDefaultChange(
                                            //     field.id,
                                            //     e.target.value
                                            //   )
                                            // }
                                            disabled
                                            sx={{
                                              fontSize: "16px",
                                              opacity: 1,
                                              "& input": {
                                                opacity: 1,
                                                height: "100%",
                                                padding: "0px 10px",
                                              },
                                            }}
                                        >
                                          {(() => {
                                            const foundItem = field.DropDownItems;
                                            if (foundItem) {
                                              return foundItem.map((item, i) => (
                                                  <MenuItem
                                                      value={item}
                                                      key={i}
                                                      sx={{ fontSize: "16px" }}
                                                  >
                                                    {item}
                                                  </MenuItem>
                                              ));
                                            }
                                            return null;
                                          })()}
                                        </Select>
                                      </FormControl>
                                      <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "13px",
                                            mb: "20px",
                                          }}
                                      >
                                        <TextField
                                            id={`input-${field?.FormFieldId || field.id
                                            }`}
                                            placeholder="Add Options"
                                            variant="outlined"
                                            style={{
                                              width: "100%",
                                              position: "relative",
                                            }}
                                            inputProps={{
                                              style: {
                                                fontSize: "16px",
                                              }
                                            }}
                                        />
                                        <IconButton
                                            onClick={() =>
                                                this.changeInput(
                                                    field.FormFieldId || field.id,
                                                    field.FormFieldId
                                                )
                                            }
                                            style={{
                                              transform: "scale(1.2)",
                                              cursor: "pointer",
                                            }}
                                        >
                                          <AddIcon
                                              height={20}
                                              width={20}
                                              style={{
                                                background: "green",
                                                borderRadius: "50%",
                                                color: "white",
                                              }}
                                          />
                                        </IconButton>
                                      </Box>
                                      {field?.DropDownItems?.length > 0 ? (
                                          <Box
                                              sx={{
                                                display: "flex",
                                                gap: "10px",
                                                flexWrap: "wrap",
                                              }}
                                          >
                                            {field.DropDownItems.map((item, i) => (
                                                <div
                                                    key={i}
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      paddingBlock: "3px",
                                                      paddingInline: "6px",
                                                      gap: "10px",
                                                      border: "1px solid #ccc",
                                                      borderRadius: "5px",
                                                      marginBottom: "10px",
                                                      width: "fit-content",
                                                    }}
                                                >
                                                  <Box
                                                      sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                      }}
                                                  >
                                                    {item}
                                                  </Box>
                                                  <CloseSharp
                                                      style={{ cursor: "pointer" }}
                                                      height={15}
                                                      width={15}
                                                      onClick={() =>
                                                          this.handleDeleteDropDownItem(
                                                              field.FormFieldId || field.id,
                                                              i,
                                                              field.FormFieldId
                                                          )
                                                      }
                                                  />
                                                </div>
                                            ))}
                                          </Box>
                                      ) : null}
                                    </FormGroup>
                                  </Box>
                              )}
                              {field.type === "Single Choice" && (
                                  <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        width: "100%",
                                      }}
                                  >
                                    <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: "13px",
                                          mb: "20px",
                                        }}
                                    >
                                      <TextField
                                          value={field.FieldName}
                                          placeholder="Type Question Label"
                                          onChange={(e) =>
                                              this.handleDynamicFieldChange(
                                                  field.FormFieldId || field.id,
                                                  e,
                                                  field.FormFieldId
                                              )
                                          }
                                          variant="outlined"
                                          style={{
                                            width: "100%",
                                            position: "relative",
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: "16px",
                                            },
                                            maxLength: 75,
                                          }}
                                          helperText={`${field.FieldName.length}/75`}
                                          FormHelperTextProps={{
                                            className:
                                            classes.eventDetailsAboutInputHelperText,
                                          }}
                                      />
                                    </Box>

                                    <FormGroup>
                                      {field?.DropDownItems?.length > 0 ? (
                                          <RadioGroup
                                              sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                ml: "10px",
                                                mb: "20px",
                                              }}
                                          >
                                            {field.DropDownItems.map((item, i) => (
                                                <FormControlLabel
                                                    value={item}
                                                    disabled={true}
                                                    control={
                                                      <Radio
                                                          sx={{ transform: "scale(1.4)" }}
                                                      />
                                                    }
                                                    label={
                                                      <span style={{ fontSize: "18px" }}>
                                            {item}
                                          </span>
                                                    }
                                                />
                                            ))}
                                          </RadioGroup>
                                      ) : (
                                          "Add Options to see the preview"
                                      )}

                                      <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "13px",
                                            mb: "20px",
                                          }}
                                      >
                                        <TextField
                                            id={`input-${field?.FormFieldId || field.id
                                            }`}
                                            placeholder="Add Options"
                                            variant="outlined"
                                            style={{
                                              width: "100%",
                                              position: "relative",
                                            }}
                                            inputProps={{
                                              style: {
                                                fontSize: "16px",
                                              },
                                            }}
                                        />
                                        <IconButton
                                            onClick={() =>
                                                this.changeInput(
                                                    field.FormFieldId || field.id,
                                                    field.FormFieldId
                                                )
                                            }
                                            style={{
                                              transform: "scale(1.2)",
                                              cursor: "pointer",
                                            }}
                                        >
                                          <AddIcon
                                              height={20}
                                              width={20}
                                              style={{
                                                background: "green",
                                                borderRadius: "50%",
                                                color: "white",
                                              }}
                                          />
                                        </IconButton>
                                      </Box>

                                      {field?.DropDownItems?.length > 0 ? (
                                          <Box
                                              sx={{
                                                display: "flex",
                                                gap: "10px",
                                                flexWrap: "wrap",
                                                mt: "20px",
                                              }}
                                          >
                                            {field.DropDownItems.map((item, i) => (
                                                <div
                                                    key={i}
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      paddingBlock: "3px",
                                                      paddingInline: "6px",
                                                      gap: "10px",
                                                      border: "1px solid #ccc",
                                                      borderRadius: "5px",
                                                      marginBottom: "10px",
                                                      width: "fit-content",
                                                    }}
                                                >
                                                  <Box
                                                      sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                      }}
                                                  >
                                                    {item}
                                                  </Box>
                                                  <CloseSharp
                                                      style={{ cursor: "pointer" }}
                                                      height={15}
                                                      width={15}
                                                      onClick={() =>
                                                          this.handleDeleteDropDownItem(
                                                              field.FormFieldId || field.id,
                                                              i,
                                                              field.FormFieldId
                                                          )
                                                      }
                                                  />
                                                </div>
                                            ))}
                                          </Box>
                                      ) : null}
                                    </FormGroup>
                                  </Box>
                              )}
                              {field.type === "Multiple Choice" && (
                                  <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "start",
                                        gap: "10px",
                                        width: "100%",
                                      }}
                                  >
                                    <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "start",
                                          gap: "13px",
                                          mb: "20px",
                                          width: "100%",
                                        }}
                                    >
                                      <TextField
                                          value={field.FieldName}
                                          placeholder="Type Question Label"
                                          onChange={(e) =>
                                              this.handleDynamicFieldChange(
                                                  field.FormFieldId || field.id,
                                                  e,
                                                  field.FormFieldId
                                              )
                                          }
                                          variant="outlined"
                                          style={{
                                            width: "100%",
                                            position: "relative",
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: "16px",
                                            },
                                            maxLength: 75,
                                          }}
                                          helperText={`${field.FieldName.length}/75`}
                                          FormHelperTextProps={{
                                            className:
                                            classes.eventDetailsAboutInputHelperText,
                                          }}
                                      />
                                    </Box>

                                    <FormGroup
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "20px",
                                          width: "100%",
                                        }}
                                    >
                                      <FormControl sx={{ margin: "10px" }}>
                                        {field.DropDownItems.map((option) => (
                                            <FormControlLabel
                                                key={option}
                                                disabled
                                                control={
                                                  <Checkbox
                                                      // checked={selectedValues.includes(option)}
                                                      // onChange={handleChange}
                                                      // value={option}
                                                      disabled
                                                      sx={{
                                                        transform: "scale(1.4)",
                                                        ml: "10px",
                                                      }}
                                                  />
                                                }
                                                label={
                                                  <Typography sx={{ fontSize: "18px" }}>
                                                    {option}
                                                  </Typography>
                                                }
                                            />
                                        ))}
                                      </FormControl>
                                      <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "13px",
                                            mb: "20px",
                                          }}
                                      >
                                        <TextField
                                            id={`input-${field?.FormFieldId || field.id
                                            }`}
                                            placeholder="Add Options"
                                            variant="outlined"
                                            style={{
                                              width: "100%",
                                              position: "relative",
                                            }}
                                            inputProps={{
                                              style: {
                                                fontSize: "16px",
                                              }
                                            }}
                                        />
                                        <IconButton
                                            onClick={() =>
                                                this.changeInput(
                                                    field.FormFieldId || field.id,
                                                    field.FormFieldId
                                                )
                                            }
                                            style={{
                                              transform: "scale(1.2)",
                                              cursor: "pointer",
                                            }}
                                        >
                                          <AddIcon
                                              height={20}
                                              width={20}
                                              style={{
                                                background: "green",
                                                borderRadius: "50%",
                                                color: "white",
                                              }}
                                          />
                                        </IconButton>
                                      </Box>

                                      {field?.DropDownItems?.length > 0 ? (
                                          <Box
                                              sx={{
                                                display: "flex",
                                                gap: "10px",
                                                flexWrap: "wrap",
                                              }}
                                          >
                                            {field.DropDownItems.map((item, i) => (
                                                <div
                                                    key={i}
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      paddingBlock: "3px",
                                                      paddingInline: "6px",
                                                      gap: "10px",
                                                      border: "1px solid #ccc",
                                                      borderRadius: "5px",
                                                      marginBottom: "10px",
                                                      width: "fit-content",
                                                    }}
                                                >
                                                  <Box
                                                      sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                      }}
                                                  >
                                                    {item}
                                                  </Box>
                                                  <CloseSharp
                                                      style={{ cursor: "pointer" }}
                                                      height={15}
                                                      width={15}
                                                      onClick={() =>
                                                          this.handleDeleteDropDownItem(
                                                              field.FormFieldId || field.id,
                                                              i,
                                                              field.FormFieldId
                                                          )
                                                      }
                                                  />
                                                </div>
                                            ))}
                                          </Box>
                                      ) : null}
                                    </FormGroup>
                                  </Box>
                              )}

                              <Typography
                                  sx={{
                                    textAlign: "start ",
                                    fontSize: "18px",
                                    fontWeight: "500 ",
                                    marginBlock: "10px",
                                  }}
                              >
                                Applies to <span style={{ color: "red" }}>*</span>{" "}
                              </Typography>
                              <FormGroup
                                  style={{
                                    paddingLeft: "15px",
                                    width: "100%",
                                  }}
                              >
                                <FormControlLabel
                                    control={
                                      <Checkbox
                                          checked={field.isForAllTickets}
                                          onChange={(e) =>
                                              this.handleIsForAllTicketsChange(
                                                  field.FormFieldId || field.id,
                                                  field.FormFieldId
                                              )
                                          }
                                          name={"All"}
                                          sx={{ transform: "scale(1.5)" }}
                                      />
                                    }
                                    label={
                                      <span
                                          style={{
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            letterSpacing: "1px",
                                          }}
                                      >
                                  All
                                </span>
                                    }
                                />

                                {this.state.tickets.map((key, i) => (
                                    <React.Fragment key={i}>
                                      <FormControlLabel
                                          control={
                                            <Checkbox
                                                checked={(field.associatedIds.includes(
                                                    key.TicketId
                                                ) || field.isForAllTickets)}
                                                onChange={(e) =>
                                                    this.handleCheckboxChange(
                                                        field.FormFieldId || field.id,
                                                        key.TicketId,
                                                        field.FormFieldId
                                                    )
                                                }
                                                name={key}
                                                sx={{ transform: "scale(1.5)" }}
                                            />
                                          }
                                          label={
                                            <>
                                      <span
                                          style={{
                                            fontSize: "18px",
                                          }}
                                      >
                                        {key.Title}
                                      </span>
                                            </>
                                          }
                                      />
                                      {key === "all" && (
                                          <Divider sx={{ margin: "6px" }} />
                                      )}
                                    </React.Fragment>
                                ))}
                              </FormGroup>
                            </div>
                          </div>
                        </div>
                    ))}
                  </div>
                  {questions.map((question, index) => {
                    if (
                        question &&
                        question.type === "custom" &&
                        question.label === "Custom Label"
                    ) {
                      if (question.state) {
                        return (
                            <Grid
                                item
                                xs={12}
                                align="center"
                                justifyContent="center"
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                            >
                              {/* Divider Line */}
                              <Grid item xs={12}>
                                <div
                                    style={{
                                      borderTop: "1px solid #ced4da",
                                      marginTop: "10px",
                                      marginBottom: "20px",
                                      width: "100%",
                                    }}
                                />
                              </Grid>

                              {/* Toggle Switch */}
                              <Grid
                                  item
                                  xs={12}
                                  style={{
                                    display: "flex",
                                    marginBottom: "10px", // Space below the toggle
                                  }}
                              >
                                <Switch
                                    onLabel="ON"
                                    offLabel="OFF"
                                    onChange={(checked) =>
                                        this.handleCustomQuestionSwitchChange(
                                            checked,
                                            index
                                        )
                                    }
                                    checked={question.toggleState || false}
                                    checkedIcon={false}
                                    uncheckedIcon={false}
                                    offColor="#E74C3C"
                                    onColor="#080"
                                />
                                <p
                                    style={{
                                      fontSize: "14px",
                                      marginRight: "10px",
                                      marginLeft: "10px",
                                      marginTop: "5px",
                                    }}
                                >
                                  Make this question required
                                </p>
                              </Grid>

                              {/* TextField and Remove Icon */}
                              <Grid
                                  item
                                  xs={12}
                                  lg={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "13px", // Space between TextField and IconButton
                                  }}
                              >
                                <TextField
                                    value={question.value}
                                    onChange={(e) => this.changeCustomField(e, index)}
                                    placeholder="Type Question Label"
                                    variant="outlined"
                                    style={{ width: "100%" }}
                                    inputProps={{
                                      style: {
                                        fontSize: "16px",
                                      },
                                    }}
                                />
                              </Grid>

                              {/* Tickets UI */}
                              <Grid
                                  item
                                  xs={12}
                                  style={{
                                    display: "flex",
                                    marginBottom: "10px", // Space below the toggle
                                  }}
                              >
                                <label
                                    style={{ fontSize: "16px", marginTop: "20px" }}
                                >
                                  {Tickets.discount.addDiscount.appliesTo}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                              </Grid>

                              <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    marginBottom: "20px",
                                    "& > label": {
                                      "& span:nth-child(2)": {
                                        fontSize: "16px",
                                        marginTop: "9px",
                                      },
                                    },
                                    "& > label:nth-child(1)": {
                                      borderBottom: "1px solid #ced4da",
                                      paddingBottom: "8px",
                                    },
                                  }}
                              ></Box>
                            </Grid>
                        );
                      }
                    }
                  })}
                </Grid>
              </div>

              <div
                  className={classes.addUpdateModalButtonWrapper}
                  id="eventCommonModal"
                  style={{ border: "none" }}
              >
                <Button
                    className={classes.addUpdateModalButtonCancel}
                    onClick={this.handleAddModal}
                >
                  {Text.Cancel}
                </Button>
                <Button
                    className={classes.addUpdateModalButtonSave}
                    variant={"contained"}
                    onClick={() => this.addFields()}
                    disabled={
                        this.state.questions.some(
                            (question) =>
                                question.label === "Custom Label" ||
                                question.label.trim() === ""
                        ) ||
                        this.state.newDynamicFields.some(
                            (field) =>
                                ((field.associatedIds.length === 0 && !field.isForAllTickets) || (
                                    (field.FieldType !== "Text" && field.FieldType !== "Text") &&
                                    field.DropDownItems.length === 0
                                ) || field?.FieldName?.trim().length === 0)
                        )
                    }
                >
                  {Text.Save}
                </Button>
              </div>
            </div>
          </Box>
        </Modal>
    );
  };

  deleteCustomField = (fieldId, formFieldId) => {
    this.setState({
      showConfirmationDialog: true,
      fieldToDelete: { fieldId, formFieldId },
    });
  };

  confirmDeleteCustomField = () => {
    const { fieldToDelete } = this.state;
    if (fieldToDelete) {
      this.handleDeleteDynamicField(
          fieldToDelete.fieldId,
          fieldToDelete.formFieldId
      );
    }
  };

  cancelDeleteCustomField = () => {
    this.setState({ showConfirmationDialog: false, fieldToDelete: null });
  };

  progressLoader = () => {
    const { loading } = this.state;

    return loading && <Loader />;
  };

  changeCustomField = (e, index) => {
    const { questions } = this.state;
    const updatedQuestions = questions.map((question, i) => {
      if (i === index) {
        return { ...question, value: e.target.value, label: e.target.value };
      }
      return question;
    });
    this.setState({ questions: updatedQuestions });
  };

  setFieldLabel = (e, index) => {
    const { fields, customTextFiled } = this.state;

    fields[index].value = e.currentTarget.value;
    this.setState({ fields });
  };

  termsAndConditions = () => {
    const { classes } = this.props;
    const {
      termsAndConditions,
      termsAndConditionsModal,
      currentTermsAndConditions,
      characterCount,
      maxCharacters,
    } = this.state;
    return (
        <Modal
            open={termsAndConditionsModal}
            onClose={() => this.termsAndConditionsModal(false)}
        >
          <Box className={classes.termsAndConditionsModal}>
            <p
                style={{
                  fontSize: 18,
                  padding: "20px 0px 20px 0px",
                  width: "100%",
                  textAlign: "center",
                  borderBottom: "1px solid #ced4da",
                }}
            >
              {termsAndConditions.length > 0 ? "Update " : "Add "}
              {Tickets.orderForm.termsAndConditions.headline}
            </p>
            <div style={{ width: "100%" }}>
              <TextField
                  value={currentTermsAndConditions}
                  onChange={this.handleChange}
                  multiline
                  rows={10}
                  variant="outlined"
                  style={{ width: "100%", padding: "30px" }}
                  inputProps={{
                    style: {
                      fontSize: 16,
                      paddingTop: "5px",
                      lineHeight: "20px",
                    },
                    maxLength: 4000,
                  }}

                  placeholder={Tickets.orderForm.termsAndConditions.placeHolder}
              />
              <div
                  style={{
                    marginBottom: "10px",
                    textAlign: "right",
                    color: characterCount > maxCharacters ? "red" : "inherit",
                    paddingRight: "30px",
                  }}
              >
                {characterCount}/{maxCharacters}
              </div>
            </div>
            <div className={classes.addUpdateModalButtonWrapperCondition}>
              <Button
                  className={classes.addUpdateModalButtonCancel}
                  onClick={() => this.termsAndConditionsModal(false)}
              >
                {Text.Cancel}
              </Button>
              <Button
                  className={classes.addUpdateModalButtonSave}
                  variant={"contained"}
                  onClick={() => this.addTermsAndConditions()}
              >
                {Text.Save}
              </Button>
            </div>
          </Box>
        </Modal>
    );
  };
  addTermsAndConditions = async () => {
    const { currentTermsAndConditions, termsAndConditionsFormFieldId } =
        this.state;
    const { eventId, updateOrderForm } = this.props;
    let newId;
    if (termsAndConditionsFormFieldId.length > 0) {
      let id = await updateOrderForm({
        FormFieldId: termsAndConditionsFormFieldId,
        EventId: eventId,
        FieldName: "Terms And Conditions",
        RequiredField: true,
        isForAllTickets: true,
        FieldType: "Checkbox",
        DefaultValue:
            currentTermsAndConditions.length > 0 ? currentTermsAndConditions : "",
      });
      newId = termsAndConditionsFormFieldId;
    } else {
      newId = await this.addFormField({
        EventId: eventId,
        FieldName: "Terms And Conditions",
        RequiredField: true,
        FieldType: "Checkbox",
        DefaultValue: currentTermsAndConditions,
        isForAllTickets: true,
      });
      newId = newId.FormFieldId;
    }
    this.setState({
      termsAndConditions: currentTermsAndConditions,
      termsAndConditionsModal: false,
      currentTermsAndConditions: "",
      termsAndConditionsFormFieldId: newId,
    });
  };

  render() {
    const { classes } = this.props;
    const { fields, termsAndConditions } = this.state;

    return (
        <div>
          <ToastContainer
              className="toaster-container"
              position="top-right"
              autoClose={5000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
          />

          {this.state.showConfirmationDialog && (
              <DeleteConfirmationModal
                  isOpen={this.state.showConfirmationDialog}
                  onClose={() => this.cancelDeleteCustomField()}
                  onDelete={() => this.confirmDeleteCustomField()}
                  message={constants.Text.deleteOrderFormCustomFieldMessage} // Pass the message
              />
          )}

          <TicketLayout>
            <EventHeader title={"Order Form"}>
              <Button className={classes.addButton} onClick={this.handleAddModal}>
              <span className={classes.createButtonAddText}>
                {fields.length > 2 ? "Add/Remove Question" : "Add Question"}
              </span>
                <AddIcon className={classes.createButtonPlusIcon} />
              </Button>
            </EventHeader>
            <ContentLayout>
              <Box
                  sx={{
                    display: "flex",
                    marginInline: "auto",
                    width: "80%",
                    margin: "auto",
                    padding: "20px 0px",
                    flexDirection: "column",

                    "@media (max-width: 768px)": {
                      paddingBottom: "60px",
                    },
                  }}
              >
                <Paper style={{ width: "100%" }}>
                  <Box
                      sx={{
                        padding: "2.5rem",
                      }}
                  >
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                    >
                      <Grid item xs>
                        <p style={{ fontSize: "16px" }}>
                          <strong>
                            {Tickets.orderForm.orderFormRequirements}
                          </strong>{" "}
                          - Toggle this switch on if your event requires all
                          fields to be filled out by each attendee.
                        </p>
                      </Grid>
                      <Grid item>
                        <Box display="flex" alignItems="center">
                          <Switch
                              onLabel="ON"
                              offLabel="OFF"
                              onChange={this.handleSwitchChange}
                              checked={this.state.checked}
                              checkedIcon={false}
                              uncheckedIcon={false}
                              offColor="#E74C3C"
                              onColor="#080"
                          />
                          <Box ml={1}>
                            <p style={{ fontSize: "16px" }}>
                              <strong>{this.state.checked ? "On" : "Off"}</strong>
                            </p>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Box>
            </ContentLayout>
            <ContentLayout>
              <Box
                  sx={{
                    display: "flex",
                    marginInline: "auto",
                    width: "80%",
                    margin: "auto",
                    padding: "20px 0px",
                    flexDirection: "column",

                    "@media (max-width: 768px)": {
                      paddingBottom: "60px",
                    },
                  }}
              >
                <Paper style={{ width: "100%" }}>
                  <Box
                      sx={{
                        padding: "2.5rem",
                      }}
                  >
                    <h1>{Tickets.orderForm.headline}</h1>
                    <p>{Tickets.orderForm.subHead}</p>
                    <Box
                        sx={{
                          marginTop: "30px",
                        }}
                    >
                      {fields.map((field, i) => (
                          (field.IsForAllTickets || (field.associatedIds !== undefined && field.associatedIds.length > 0) ||
                              ["Email", "Full Name", "Phone"].includes(field.label)) && (
                                <FormControl className={classes.orderForm} key={i}>
                                  <span className={classes.createEventFAQInputLabel}>
                                    {field.type === "custom" ? field.value : field.label}

                                    {field.required && (
                                        <span style={{ color: "red" }}> *</span>
                                    )}
                                  </span>
                                  {field.FieldType === "Radio" ? (
                                      <FormGroup>
                                        {field?.Options?.length > 0 ? (
                                            <RadioGroup
                                                sx={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  ml: "10px",
                                                  mb: "20px",
                                                }}
                                            >
                                              {field.Options.map((item, i) => (
                                                  <FormControlLabel
                                                      value={item}
                                                      disabled={true}
                                                      control={
                                                        <Radio sx={{ transform: "scale(1.4)" }} />
                                                      }
                                                      label={
                                                        <span style={{ fontSize: "18px" }}>
                                              {item}
                                            </span>
                                                      }
                                                  />
                                              ))}
                                            </RadioGroup>
                                        ) : (
                                            ""
                                        )}
                                      </FormGroup>
                                  ) : field.FieldType === "Dropdown" ? (
                                      <FormControl fullWidth>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={"Please Select"}
                                            disabled={true}
                                            sx={{
                                              fontSize: "16px",
                                              opacity: 1,
                                              "& input": {
                                                opacity: 1,
                                                height: "100%",
                                                padding: "0px 10px",
                                              },
                                            }}
                                        ></Select>
                                      </FormControl>
                                  ) : field.FieldType === "Multi-Select" ? (
                                      <FormGroup
                                          sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "20px",
                                            width: "100%",
                                          }}
                                      >
                                        <FormControl sx={{ margin: "10px" }}>
                                          {field.Options.map((option) => (
                                              <FormControlLabel
                                                  key={option}
                                                  disabled
                                                  control={
                                                    <Checkbox
                                                        // checked={selectedValues.includes(option)}
                                                        // onChange={handleChange}
                                                        // value={option}
                                                        disabled
                                                        sx={{
                                                          transform: "scale(1.4)",
                                                          ml: "10px",
                                                        }}
                                                    />
                                                  }
                                                  label={
                                                    <Typography sx={{ fontSize: "18px" }}>
                                                      {option}
                                                    </Typography>
                                                  }
                                              />
                                          ))}
                                        </FormControl>
                                      </FormGroup>
                                  ) : (
                                      <TextField
                                          required={field.required}
                                          placeholder={
                                            field.type === "custom"
                                                ? field.value
                                                : field.label
                                          }
                                          margin="normal"
                                          disabled={true}
                                          fullWidth
                                          type="text"
                                          InputProps={{
                                            disableUnderline: true,
                                            className: classes.createEventFAQInputText,
                                          }}
                                      />
                                  )}
                            </FormControl>
                          )
                          ))}
                    </Box>
                    {this.addModal()}
                  </Box>
                </Paper>
                <p
                    style={{
                      padding: "15px 25px",
                      color: "#a338a4",
                      cursor: "pointer",
                    }}
                    onClick={() => this.termsAndConditionsModal(true)}
                >
                  {termsAndConditions.length > 0 ? "Update " : "Add "}
                  {Text.AdditionalTerms}
                </p>
              </Box>
              <div style={{ flex: 0.1 }}>{this.saveAndContinue()}</div>
            </ContentLayout>
            {this.progressLoader()}
            {this.termsAndConditions()}
          </TicketLayout>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { eventUserEvents } = state;
  return {
    eventId: eventUserEvents.eventId,
    discounts: eventUserEvents.discounts,
    orderForms: state.eventUserEvents.orderForms,
  };
};
const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
      { addOrderForm, updateOrderForm, deleteOrderForm },
      dispatch
  );
};

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withStyles(styles)(orderForm));
